var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('externalFrame',[_c('div',{staticStyle:{"padding":"20px"}},[_c('login',{attrs:{"targetURL":_vm.targetURL},on:{"loginsuccess":_vm.loginsuccess}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }